import { Accordion } from '@/components/accordion'
import { Table as MaintenanceEventsTable } from '@/components/maintenance_event/table'
import { MaintenanceEventState } from '@/types'
import { Form as MaintenanceEventForm } from '@/components/maintenance_event/add_maintenance_event'

export const Index = () => {
  return (
    <>
      <div className="flex flex-col gap-6">
        <MaintenanceEventForm />
        <Accordion title="Continue where you left off" defaultOpen>
          <MaintenanceEventsTable filters={{ stateEq: MaintenanceEventState.Started }} fixedHeight />
        </Accordion>
        <Accordion title="Overdue tasks" defaultOpen>
          <MaintenanceEventsTable filters={{ overdue: true }} fixedHeight />
        </Accordion>
        <Accordion title="Upcoming tasks">
          <MaintenanceEventsTable filters={{ upcoming: true }} fixedHeight />
        </Accordion>
        <Accordion title="Recently completed tasks">
          <MaintenanceEventsTable filters={{ stateEq: MaintenanceEventState.Completed }} fixedHeight />
        </Accordion>
      </div>
    </>
  )
}
